<template>
  <div id="channel-basket">
    <div v-if="loadTable">
      <div class="vx-row" v-if="basket.basketState == 'RejectedState'">
        <div class="vx-col w-full mb-4">
          <vs-alert class="bg-danger text-white">
            {{ $t("ReasonOfOrderReject") }} : {{ basket.reasonOfReject }}
          </vs-alert>
        </div>
      </div>
      <div class="vx-row hide-in-print">
        <div class="vx-col w-full mb-6">
          <vs-button
            type="filled"
            icon="done"
            id="l-confirm-btn"
            class="float-right purple mx-2"
            @click.prevent="confirmOrder(basket.id)"
            :disabled="disabled"
            v-if="basket.basketFlowState == '1'"
            v-has-permission="permission226"
            >{{ $t("ConfirmOrder") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right mx-2"
            id="l-confirm-btn"
            @click.prevent="isShowDescriptionDateSettlement()"
            :disabled="disabled"
            v-if="basket.basketState == 'OpenState'"
            >{{ $t("CloseOrderBasket") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right mx-2"
            id="submit-btn"
            @click.prevent="showAttachments()"
            v-if="basket.basketState != 'OpenState'"
            >{{ $t("Attachments") }}</vs-button
          >
          <vs-button
            type="filled"
            icon="assignment_turned_in"
            class="float-right mx-2 btn_l_blue"
            id="submit-btn"
            @click.prevent="orderDelivered(basket.id)"
            :disabled="disabledDelivered"
            v-if="basket.basketFlowState == '4'"
            >{{ $t("Delivered") }}</vs-button
          >
          <vs-button
            type="button"
            icon="clear"
            class="float-right purple mx-2"
            id="l-reject-btn"
            v-has-permission="permission227"
            @click.prevent="rejectOrder(basket.id)"
            :disabled="disabledReject"
            v-if="
              basket.basketFlowState == '1' ||
              basket.basketState == 'OpenState' ||
              basket.basketState == 'CloseState' ||
              basket.basketFlowState == '6'
            "
            >{{ $t("RejectOrder") }}</vs-button
          >
          <vs-button
            type="button"
            class="float-left mx-2"
            style="background-color: #444"
            @click.prevent="backToCurrentGrid()"
            >{{ $t("Back") }}</vs-button
          >
        </div>
      </div>
      <div class="vx-row">
        <div v-if="showFiles" class="w-full md:w-1/2 lg:w-1/4 mb-4">
          <files-and-attachments-for-show
            :basketId="basketId"
            @showDetials="showDetials"
          ></files-and-attachments-for-show>
        </div>
        <div
          class="vx-col w-full mb-4 md:w-1/2"
          :class="showFiles ? 'lg:w-1/4' : 'lg:w-1/3'"
        >
          <div class="vx-card mb-4 user-info">
            <div class="vx-card__header">
              <div class="vx-card__title">
                <h4>{{ $t("PartyInfo") }}</h4>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body custom-tbl v-table">
                <vs-table :data="basket" ref="table">
                  <template :name="{ data }" slot-scope="{ data }">
                    <vs-tr>
                      <vs-td>
                        {{ $t("Name") }}
                      </vs-td>
                      <vs-td>
                        {{ basket.basketCustomerInfo.name }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr
                      v-if="basket.basketCustomerInfo.partyType == 'Legal'"
                    >
                      <vs-td>
                        {{ $t("CompanyRegistrationNumber") }}
                      </vs-td>
                      <vs-td>
                        {{
                          basket.basketCustomerInfo.companyRegistrationNumber
                        }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr
                      v-if="basket.basketCustomerInfo.partyType == 'Legal'"
                    >
                      <vs-td>
                        {{ $t("EconomicCode") }}
                      </vs-td>
                      <vs-td>
                        {{ basket.basketCustomerInfo.economicCode }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr
                      v-if="basket.basketCustomerInfo.partyType == 'Individual'"
                    >
                      <vs-td>
                        {{ $t("SocialSecurityNumber") }}
                      </vs-td>
                      <vs-td>
                        {{ basket.basketCustomerInfo.socialSecurityNumber }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Email") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="basket.basketCustomerInfo.email">
                          {{ basket.basketCustomerInfo.email }}
                        </span>
                        <span v-if="!basket.basketCustomerInfo.email"> - </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("PhoneNumber") }}
                      </vs-td>
                      <td
                        v-for="item in basket.basketCustomerInfo.phones"
                        :key="item.id"
                        style="direction: ltr"
                      >
                        <span v-if="item.area">{{ item.area }}-</span>
                        {{ item.number }}
                      </td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("PostalCode") }}
                      </vs-td>
                      <td
                        v-for="item in basket.basketCustomerInfo.addressesInfo"
                        :key="item.id"
                      >
                        {{ item.postalCode }}
                      </td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td> {{ $t("Address") }} </vs-td>
                      <td
                        v-for="item in basket.basketCustomerInfo.addressesInfo"
                        :key="item.id"
                      >
                        {{ item.provinceInfo.name }}-{{
                          item.provinceInfo.cityName
                        }}-{{ item.address }}
                      </td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <!-- Summary -->
        <div
          class="vx-col w-full mx-0 md:w-1/2"
          :class="showFiles ? 'lg:w-1/4' : 'lg:w-1/3'"
        >
          <div class="vx-card mb-4 p-1">
            <div class="vx-card__header p-0 mt-1 mb-6">
              <div class="vx-card__title w-full">
                <h4 class="d-inline float-left mt-4 mr-4">
                  {{ $t("OrderInfo") }}
                </h4>
                <vs-chip
                  transparent
                  color="warning"
                  class="float-right hide-in-print"
                >
                  <span v-if="basket.basketFlowState == '1'">
                    {{ $t("ReviewQueue") }}
                  </span>
                  <span v-if="basket.basketFlowState == '2'">
                    {{ $t("Confirmed") }}
                  </span>
                  <span v-if="basket.basketFlowState == '3'">
                    {{ $t("Processing") }}
                  </span>
                  <span v-if="basket.basketFlowState == '4'">
                    {{ $t("Sent") }}
                  </span>
                  <span v-if="basket.basketFlowState == '5'">
                    {{ $t("Delivered") }}
                  </span>
                </vs-chip>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body custom-tbl v-table">
                <vs-table :data="basket" ref="orderTable">
                  <template :name="{ data }" slot-scope="{ data }">
                    <vs-tr>
                      <vs-td>
                        {{ $t("OrderNumber") }}
                      </vs-td>
                      <vs-td>
                        {{ siteOrderNumber }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("TotalAmount") }}
                      </vs-td>
                      <vs-td>
                        {{ Number(basket.sumOfFinalPrice).toLocaleString() }}
                        {{ $t("Rials") }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("ShippingFee") }}
                      </vs-td>
                      <vs-td>
                        {{ Number(basket.shippingFee).toLocaleString() }}
                        {{ $t("Rials") }}
                      </vs-td>
                    </vs-tr>

                    <vs-tr>
                      <vs-td>
                        {{ $t("SumOfDiscount") }}
                      </vs-td>
                      <vs-td>
                        {{
                          amountDiscount
                            ? amountDiscount
                            : basket.immediateDiscountAmount == null
                            ? 0
                            : Number(
                                basket.immediateDiscountAmount
                              ).toLocaleString()
                        }}
                        {{ $t("Rials") }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("ToPay") }}
                      </vs-td>
                      <vs-td>
                        {{
                          newTotalAmount
                            ? Number(newTotalAmount).toLocaleString()
                            : Number(basket.totalAmount).toLocaleString()
                        }}
                        ریال
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("PaymentStatus") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="basket.paymentType == 1">
                          {{ $t("CreditPayment") }}
                        </span>
                        <span v-if="basket.paymentType == 2">
                          {{ $t("OnlinePayment") }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("AmountCommission") }}
                      </vs-td>
                      <vs-td>
                        {{
                          amountCommission
                            ? amountCommission
                            : Number(basket.commissionAmount).toLocaleString()
                        }}
                        ریال
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="vx-col w-full mb-4 md:w-1/2"
          :class="showFiles ? 'lg:w-1/4' : 'lg:w-1/3'"
        >
          <div class="vx-card mb-4 user-info p-2">
            <!-- <div class="vx-card__header">
              <div class="vx-card__title w-full"> -->
            <!-- <h4>
                  <vs-button
                    type="gradient"
                    icon-pack="feather"
                    class="bg_l_green float-right"
                    @click="onCreateNewRecipient"
                    >{{ $t("AddRecipientInfo") }}</vs-button
                  >
                  <span class="mt-2 float-left">
                    {{ $t("RecipientInfo") }}
                  </span>
                </h4> -->
            <!-- </div>
            </div> -->
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div
                      class="recipient-list transferee-options"
                      v-for="(recipient, index) in recipients"
                      :key="index"
                    >
                      <div
                        class="w-full vx-row recipient-itemp-0 m-0"
                        :class="[
                          basket.recipientInfo &&
                          recipient.id != basket.recipientInfo.id
                            ? 'opacity-75 cursor-not-allowed pointer-events-none'
                            : '',
                        ]"
                      >
                        <label
                          :for="'recipient' + index"
                          class="pb-0 pt-1 px-3"
                        >
                          <div>
                            <div class="vx-row mb-2">
                              <input
                                class="custom-input-button m-2"
                                type="radio"
                                :id="'recipient' + index"
                                name="transferee"
                                :checked="
                                  basket.recipientInfo
                                    ? recipient.id == basket.recipientInfo.id
                                      ? true
                                      : false
                                    : recipient.id
                                "
                                @click="changerecipient(recipient)"
                              />
                              <span class="m-0 mt-1">
                                <strong>{{ $t("Receiver") }}: </strong>
                                <span
                                  style="font-size: 1.2rem; font-weight: bold"
                                >
                                  {{ recipient.fullName }}
                                </span>
                              </span>
                            </div>
                            <span class="mx-4">
                              <strong>{{ $t("Address") }}: </strong>
                              <span>
                                {{ recipient.addressInfo.province.name }}-{{
                                  recipient.addressInfo.province.cityName
                                }}-{{ recipient.addressInfo.address }}
                              </span>
                            </span>
                            <span class="mx-4">
                              <strong>{{ $t("PostalCode") }}:</strong>
                              <span>{{
                                recipient.addressInfo.postalCode
                                  ? recipient.addressInfo.postalCode
                                  : "---"
                              }}</span>
                            </span>

                            <span class="mx-4">
                              <strong>{{ $t("PhoneNumber") }}: </strong>
                              <span class="ml-8">{{
                                recipient.phoneNumber
                                  ? recipient.phoneNumber
                                  : "---"
                              }}</span>
                            </span>
                            <span class="mx-4" v-if="recipient.mobileNumber">
                              <strong> {{ $t("MobileNumber") }}: </strong>
                              <span>{{
                                recipient.mobileNumber
                                  ? recipient.mobileNumber
                                  : "---"
                              }}</span>
                            </span>
                          </div>
                          <!-- <div class="w-1/5">
                            <vs-button
                              type="filled"
                              class="float-right my-8 px-8"
                              @click.prevent="editRecipient(recipient)"
                              >{{ $t("Edit") }}</vs-button
                            >
                          </div> -->
                        </label>
                      </div>
                    </div>
                    <!-- <div class="vx-row hide-in-print">
                      <div class="vx-col w-full">
                        <vs-button
                          type="filled"
                          class="float-right bg_l_green mr-4"
                          @click.prevent="submitRecipient()"
                          >{{ $t("SubmitChanges") }}</vs-button
                        >
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="vx-row" v-if="recipients.length == 0">
                  <div class="vx-col w-full">
                    <div class="no-info">
                      {{ $t("RecipientDeliveryNentered") }}!
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row W-full" v-if="test.isShow">
        <div>
          <img :src="test.url" class="block mx-auto w-full my-0 text-center" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-card mb-4">
            <div class="vx-card__header">
              <div class="vx-card__title w-full">
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  class="bg_l_purple float-right py-1 px-5"
                  v-show="onShowDiscount"
                  @click="isShowBoxDiscount"
                  v-has-permission="permission224"
                  >{{ $t("Discounts") }}</vs-button
                >
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  class="mx-2 bg_l_purple float-right py-1 px-5"
                  v-show="onShowCommission"
                  @click="isShowBoxCommission"
                  >{{ $t("Commission") }}</vs-button
                >
                <span class="mt-2 float-left">
                  {{ $t("OrdersList") }}
                </span>
                <router-link
                  :to="{ path: '/channelbaskets/editbasket/' + basket.id }"
                  v-if="basket.basketState == 'OpenState'"
                  class="float-right"
                >
                  <vs-button
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="mr-4 bg_l_blue"
                    v-has-permission="permission225"
                    >{{ $t("Edit") }}</vs-button
                  >
                </router-link>

                <span class="date float-right mt-2">
                  <span> {{ $t("CreateOn") }}: </span>
                  <span class="float-right" style="direction: ltr">
                    {{ basket.createOn }}
                  </span>
                </span>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body custom-tbl" id="draft-order-tbl">
                <div v-show="showBoxDiscount" class="vx-row w-full mb-4">
                  <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
                    <vs-input
                      type="gradient"
                      icon-pack="feather"
                      class="inputx"
                      name="fName"
                      :label="$t('SumOfDiscount')"
                      v-model="amountDiscountManual"
                    />
                  </div>
                  <div>
                    {{ $t("Rials") }}
                    <vs-button
                      type="filled"
                      class="submit-btn py-1 px-4 mt-6 mx-4"
                      @click="submitDiscounts()"
                      >{{ $t("DiscountSubmit") }}</vs-button
                    >
                  </div>
                </div>
                <div v-show="showBoxCommission" class="vx-row w-full mb-4">
                  <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
                    <vs-input
                      type="gradient"
                      icon-pack="feather"
                      class="inputx"
                      name="fName"
                      :label="$t('AmountCommission')"
                      v-model="amountCommissionManual"
                      @keyup.enter="submitCommission()"
                    />
                  </div>
                  <div>
                    {{ $t("Rials") }}
                    <vs-button
                      type="filled"
                      class="submit-btn py-1 px-4 mt-6 mx-4"
                      @click="submitCommission()"
                      >{{ $t("CommissionSubmit") }}</vs-button
                    >
                  </div>
                </div>
                <vs-table
                  :data="basket.saleAgentBasketItemsQueryDto"
                  ref="tableProduct"
                >
                  <template slot="thead">
                    <vs-th style="width: 3%">#</vs-th>
                    <vs-th style="width: 10%">{{ $t("ProductName") }}</vs-th>
                    <vs-th style="width: 10%">{{ $t("PersianName") }}</vs-th>
                    <vs-th style="width: 10%">{{ $t("ItemCode") }}</vs-th>
                    <vs-th style="width: 10%">{{ $t("ProductColor") }}</vs-th>
                    <vs-th style="width: 10%">{{
                      $t("ProductWarranty")
                    }}</vs-th>
                    <vs-th style="width: 4%">{{ $t("Count") }}</vs-th>
                    <vs-th style="width: 10%">{{ $t("UnitPrice") }}</vs-th>
                    <vs-th style="width: 10%">{{ $t("SumOfDiscount") }}</vs-th>
                    <vs-th style="width: 10%">{{ $t("TotalTaxAmount") }}</vs-th>
                    <vs-th style="width: 10%">{{
                      $t("TotalAmountWithTax")
                    }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      v-for="(tr, indextr) in data"
                      :data="tr"
                      :key="indextr"
                    >
                      <vs-td :data="data[indextr]">
                        {{ parseInt(indextr) + 1 }}
                      </vs-td>
                      <vs-td
                        :data="data[indextr].basketProductInfo.productInfoName"
                      >
                        {{ data[indextr].basketProductInfo.productInfoName }}
                      </vs-td>
                      <vs-td
                        :data="data[indextr].basketProductInfo.productInfoName"
                      >
                        {{
                          data[indextr].basketProductInfo.productInfoPersianName
                        }}
                      </vs-td>
                      <vs-td
                        :data="
                          data[indextr].basketProductInfo.productInfoItemCode
                        "
                      >
                        {{
                          data[indextr].basketProductInfo.productInfoItemCode
                        }}
                      </vs-td>
                      <vs-td
                        :data="data[indextr].basketProductInfo.color.colorName"
                      >
                        {{ data[indextr].basketProductInfo.color.colorName }}
                      </vs-td>
                      <vs-td
                        :data="
                          data[indextr].basketProductInfo.warranty.warrantyName
                        "
                      >
                        {{
                          data[indextr].basketProductInfo.warranty.warrantyName
                        }}
                      </vs-td>
                      <vs-td :data="data[indextr].count">
                        {{ data[indextr].count }}
                      </vs-td>
                      <vs-td :data="data[indextr].contractPrice">
                        {{
                          Number(data[indextr].contractPrice).toLocaleString()
                        }}
                        {{ $t("Rials") }}
                      </vs-td>
                      <vs-td :data="data[indextr].totalDiscountsAmount">
                        <span v-if="data[indextr].totalDiscountsAmount">
                          {{
                            Number(
                              data[indextr].totalDiscountsAmount
                            ).toLocaleString()
                          }}
                          {{ $t("Rials") }}
                        </span>
                        <span v-else> - </span>
                      </vs-td>
                      <vs-td :data="data[indextr].totalTax">
                        {{ Number(data[indextr].totalTax).toLocaleString() }}
                        {{ $t("Rials") }}
                      </vs-td>
                      <vs-td :data="data[indextr].totalBaseConsumerPrice">
                        {{
                          Number(
                            data[indextr].totalBaseConsumerPrice
                          ).toLocaleString()
                        }}
                        {{ $t("Rials") }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr style="background-color: #007470; color: white">
                      <vs-td>مجموع</vs-td>
                      <vs-td> </vs-td>
                      <vs-td> </vs-td>
                      <vs-td> </vs-td>
                      <vs-td> </vs-td>
                      <vs-td> </vs-td>
                      <vs-td>
                        {{ basket.sumOfCount }}
                      </vs-td>
                      <vs-td> </vs-td>
                      <vs-td>
                        {{ basket.sumOfDiscountAmount.toLocaleString() }}
                      </vs-td>
                      <vs-td>
                        {{ basket.sumOfTotalTax.toLocaleString() }}
                      </vs-td>
                      <vs-td> {{ basket.totalAmount.toLocaleString() }} </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid md:grid-cols-2 grid-cols-1 gap-6 grid-rows-1 items-center mb-6"
      >
        <div class="grid-col-span-1 w-full h-full">
          <div class="vx-card h-full">
            <div class="vx-card__header">
              <div class="vx-card__title">
                <h4>{{ $t("BasketDetails") }}</h4>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body custom-tbl v-table">
                <vs-table :data="basket" ref="paymentTable">
                  <template :name="{ data }" slot-scope="{ data }">
                    <vs-tr>
                      <vs-td>
                        {{ $t("Description") }}
                      </vs-td>
                      <vs-td>
                        <span>
                          {{
                            basket.description
                              ? basket.description
                              : "بدون توضیحات"
                          }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Considerations") }}
                      </vs-td>
                      <vs-td>
                        <span>
                          {{
                            basket.considerations
                              ? basket.considerations
                              : "بدون ملاحضات"
                          }}
                        </span>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col-span-1 w-full h-full">
          <div class="vx-card h-full">
            <div class="vx-card__header">
              <div class="vx-card__title">
                <h4>{{ $t("PaymentInfo") }}</h4>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body custom-tbl v-table">
                <vs-table :data="basket" ref="paymentTable">
                  <template :name="{ data }" slot-scope="{ data }">
                    <vs-tr v-if="basket.settlementDate">
                      <vs-td>
                        {{ $t("DateSettlement") }}
                      </vs-td>
                      <vs-td>
                        <span> {{ basket.settlementDate }} </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="basket.paymentState">
                      <vs-td>
                        {{ $t("PaymentGateway") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="basket.payment">
                          <span v-if="basket.payment.bankType == 1">ملت</span>
                          <span v-else-if="basket.payment.bankType == 2"
                            >ملی</span
                          >
                          <span v-else-if="basket.payment.bankType == 3"
                            >مسکن</span
                          >
                          <span v-else-if="basket.payment.bankType == 4"
                            >سپه</span
                          >
                          <span v-else-if="basket.payment.bankType == 5"
                            >پاسارگاد</span
                          >
                          <span v-else-if="basket.payment.bankType == 6"
                            >پارسیان</span
                          >
                          <span v-else-if="basket.payment.bankType == 7"
                            >ایران خودرو</span
                          >
                          <span v-else>متفرقه</span>
                        </span>
                        <span v-else>--- </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="basket.paymentState">
                      <vs-td>
                        {{ $t("ReceiptNumber") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="basket.payment">
                          {{ basket.payment.referenceId }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="basket.paymentState">
                      <vs-td>
                        {{ $t("Date") }}
                      </vs-td>
                      <vs-td style="direction: ltr">
                        <div v-if="basket.paymentType == 1">
                          {{ basket.actionTime }}
                        </div>
                        <div v-if="basket.payment && basket.paymentType == 2">
                          {{ basket.payment.referenceTime }}
                        </div>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="basket.paymentState">
                      <vs-td>
                        {{ $t("Fee") }}
                      </vs-td>
                      <vs-td>
                        {{ Number(basket.totalAmount).toLocaleString() }} ریال
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="basket.paymentState">
                      <vs-td>
                        {{ $t("Status") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="basket.paymentState == 'Rejected'">
                          <span class="red">
                            {{ $t("Rejected") }}
                          </span>
                        </span>
                        <span v-if="basket.paymentState == 'CreditPayment'">
                          {{ $t("CreditPayment") }}
                        </span>
                        <span v-if="basket.paymentState == 'Confirmed'">
                          <span class="green">
                            {{ $t("Confirmed") }}
                          </span>
                        </span>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <div
                  v-if="!basket.paymentState"
                  class="flex w-full justify-center items-center h-full"
                >
                  <span class="font-bold"
                    >{{ $t("NoPaymentInformation") }}!</span
                  >
                </div>
              </div>
            </div>
            <description-dateSettlement-popup
              :show="showDescriptionDateSettlement"
              @CloseOrderBasket="CloseOrderBasket"
              @finish="onfinish"
            ></description-dateSettlement-popup>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full flex justify-end gap-4">
          <vs-button
            type="button"
            icon="clear"
            class="float-right purple"
            id="l-reject-btn"
            v-has-permission="permission227"
            @click.prevent="rejectOrder(basket.id)"
            :disabled="disabledReject"
            v-if="
              basket.basketFlowState == '1' ||
              basket.basketState == 'OpenState' ||
              basket.basketState == 'CloseState' ||
              basket.basketFlowState == '6'
            "
            >{{ $t("RejectOrder") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="l-confirm-btn"
            @click.prevent="isShowDescriptionDateSettlement()"
            :disabled="disabled"
            v-if="basket.basketState == 'OpenState'"
            >{{ $t("CloseOrderBasket") }}</vs-button
          >
          <vs-button
            type="filled"
            icon="done"
            id="l-confirm-btn"
            class="float-right purple"
            @click.prevent="confirmOrder(basket.id)"
            :disabled="disabled"
            v-if="basket.basketFlowState == '1'"
            v-has-permission="permission226"
            >{{ $t("ConfirmOrder") }}</vs-button
          >
        </div>
      </div>
    </div>
    <div class="loadingsec" v-if="showLoading">
      <svg
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  </div>
</template>
<style lang="scss">
#channel-recipient-tbl tr td:nth-child(2n + 1) {
  width: 35%;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 1em !important;
}
.vs-table--tbody-table {
  min-width: 150px !important;
}
.loadingsec {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#buyer-recipient-info .remove-btn {
  position: absolute;
  top: 1.1rem;
  left: 1.1rem;
}
.theme-dark .vs-con-table .vs-con-tbody .vs-table--tbody-table tr {
  background-color: #1d1d1e !important;
}

.theme-dark #draft-order-tbl .tr-values:hover {
  background-color: #583636c8 !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
  isMobile,
  mobileVendor,
  mobileModel,
} from "mobile-device-detect";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_webOrderdetails.scss";
import FilesAndAttachmentsForShow from "./FilesAndAttachmentsForShow.vue";
import DescriptionDateSettlementPopup from "./DescriptionDateSettlementPopup.vue";
export default {
  name: "basketManagement_ChannelBaskets_BasketDetails",
  components: {
    FilesAndAttachmentsForShow,
    DescriptionDateSettlementPopup,
  },
  data() {
    return {
      test: {},
      showDescriptionDateSettlement: false,
      showFiles: false,
      basketId: "",
      permission224: "ApplyImmediateDiscountToBasket",
      permission225: "ModifyBasket",
      permission226: "ChangeStateToConfirmForSaleAgentBasket",
      permission227: "ChangeStateToRejectBasket",
      onShowDiscount: false,
      onShowCommission: false,
      onShowDiscountCount: 0,
      ownerUserId: "",
      Ids: {},
      agentId: "",
      ownerUserName: "",
      amountDiscount: "",
      amountCommission: "",
      amountCommissionManual: "",
      amountDiscountManual: "",
      newTotalAmount: "",
      discountModel: {
        basketId: "",
        amount: "",
      },
      commissionModel: {
        basketId: "",
        commissionAmount: "",
      },
      showBoxDiscount: false,
      showBoxCommission: false,
      basket: {},
      createModelRecipient: {},
      loadTable: false,
      hasMainAgnet: false,
      disabled: false,
      disabledReject: false,
      disabledDelivered: false,
      siteOrderNumber: "",
      recipientModel: {},
      showLoading: false,
      closeBasketModel: {
        basketId: null,
        paymentType: 1,
        isDesktop: !isMobile,
        osInfo: osName + osVersion,
        browserName: browserName + browserVersion,
        deviceName: mobileVendor === "none" ? "" : mobileVendor + mobileModel,
        ip: "",
      },
      selectedRecipient: {},
      disabledRecipientBtn: false,
      recipientChanged: false,
    };
  },
  computed: {
    ...mapGetters({
      mainbasket: "basket/agentBasketDetails",
      recipients: "recipientsShipping/agentRecipients",
    }),
  },
  mounted() {
    this.showLoading = true;
    this.getIP();
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSaleAgentBasket: "basket/fetchSaleAgentBasket",
      submitDiscountMethods: "basket/submitDiscountApi",
      submitCommissionMethods: "basket/submitCommissionApi",
      closeBasket: "basket/closeSaleAgentBasket",
      confirmBasketOrder: "basket/confirmAgentBasket",
      basketOrderDelivered: "basket/basketDelivered",
      rejectBasketOrder: "basket/rejectBasket",
      fetchAgentRecipients: "recipientsShipping/fetchAgentRecipients",
      fetchAgentWhoHasMembersRecipients:
        "recipientsShipping/fetchAgentWhoHasMembersRecipients",
      createBasketRecipientInfo: "sale/createBasketRecipients",
    }),
    async load() {
      var id = this.$route.params.id;
      this.basketId = id;
      this.onShowDiscountCount = this.$route.params.tabIndex;
      if (this.onShowDiscountCount == 1 || this.onShowDiscountCount == 0) {
        this.onShowDiscount = true;
        this.onShowCommission = true;
      } else {
        this.onShowDiscount = false;
        this.onShowCommission = false;
      }
      this.discountModel.basketId = id;
      this.commissionModel.basketId = id;
      await this.fetchSaleAgentBasket(id).then((r) => {
        this.agentId = r.basketCustomerInfo.customerId;
        this.hasMainAgnet = r.saleAgentInfoBasketQuery ? true : false;
        this.initialImplementation(this.agentId, this.hasMainAgnet);
      });
    },
    changerecipient(selectrecipient) {
      if (this.createModelRecipient.id != selectrecipient.id) {
        this.recipients.forEach((elem) => {
          elem.isDefault = false;
          if (elem.id == selectrecipient.id) {
            elem.isDefault = true;
            this.createModelRecipient = {
              basketId: this.$route.params.id,
              ownerUserId: this.basket.ownerUserId,
              id: elem.id,
              ssn: elem.ssn,
              no: "",
              unit: elem.unit,
              fullName: elem.fullName,
              phoneNumber: elem.phoneNumber,
              mobileNumber: elem.mobileNumber,
              addressInfo: elem.addressInfo,
              longitude: elem.longitude,
              latitude: elem.latitude,
            };
          }
        });
      }
    },
    isShowBoxDiscount() {
      if (this.showBoxDiscount) {
        this.showBoxDiscount = false;
      } else {
        this.showBoxDiscount = true;
        this.showBoxCommission = false;
      }
    },
    isShowBoxCommission() {
      if (this.showBoxCommission) {
        this.showBoxCommission = false;
      } else {
        this.showBoxCommission = true;
        this.showBoxDiscount = false;
      }
    },
    submitDiscounts() {
      this.submitDiscountMethods(this.discountModel).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "مبلغ تخفیف با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.amountDiscount = this.amountDiscountManual;
        this.newTotalAmount = this.basket.totalAmount - this.amountDiscount;
      });
    },
    submitCommission() {
      this.submitCommissionMethods(this.commissionModel).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "مبلغ کمیسیون با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.amountCommission = this.amountCommissionManual;
      });
    },
    initialImplementation(agentId, memberHasMainAgnet) {
      this.basket = this.mainbasket;
      this.ownerUserId = this.basket.ownerUserId;
      if (memberHasMainAgnet) {
        this.fetchAgentWhoHasMembersRecipients(
          this.basket.saleAgentInfoBasketQuery.ownerId
        ).then(() => {});
      } else {
        this.Ids.ownerUserId = this.basket.ownerUserId;
        this.Ids.agentId = agentId;

        this.fetchAgentRecipients(this.Ids).then(() => {});
      }
      // var basketIdFormat = ("0000" + this.basket.id).substr(-4);
      this.siteOrderNumber = "APO-" + this.basket.id;
      this.closeBasketModel.basketId = this.basket.id;
      if (this.showLoading) {
        setTimeout(() => {
          this.showLoading = false;
          this.loadTable = true;
        }, 1500);
      }
    },
    getIP() {
      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          if (ip != null) {
            this.closeBasketModel.ip = ip;
          }
        });
    },
    async submitRecipient() {
      if (!this.createModelRecipient.id) {
        let elem = this.recipients[this.recipients.length - 1];
        this.createModelRecipient = {
          basketId: this.$route.params.id,
          ownerUserId: this.basket.ownerUserId,
          id: elem.id,
          ssn: elem.ssn,
          no: "",
          unit: elem.unit,
          fullName: elem.fullName,
          phoneNumber: elem.phoneNumber,
          mobileNumber: elem.mobileNumber,
          addressInfo: elem.addressInfo,
          longitude: elem.longitude,
          latitude: elem.latitude,
        };
      }
      await this.createBasketRecipientInfo(this.createModelRecipient).then(
        () => {}
      );
    },
    isShowDescriptionDateSettlement() {
      this.showDescriptionDateSettlement = true;
    },
    async CloseOrderBasket(modelForClose) {
      for (let index = 0; index < this.recipients.length; index++) {
        if (this.recipients[index].isDefault) {
          this.selectedRecipient = this.recipients[index];
          if (this.selectedRecipient.mobileNumber) {
            this.selectedRecipient.mobileNumber =
              this.selectedRecipient.phoneNumber;
          }
        }
      }
      await this.submitRecipient();
      this.$swal({
        title: "آیا از بستن سبد این سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.showLoading = true;
          this.disabled = true;
          this.closeBasketModel.settlementDate = modelForClose.DateSettlement;
          this.closeBasketModel.description = modelForClose.description;
          this.closeBasketModel.considerations = modelForClose.considerations;
          this.closeBasket(this.closeBasketModel).then(() => {
            this.showLoading = false;
            this.disabled = false;
            this.showDescriptionDateSettlement = false;
            this.$swal({
              position: "center-center",
              type: "success",
              text: "سفارش مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.push({
                path: "/ChannelBaskets/Index",
                query: {
                  referencePageInfo: {
                    tabIndex: +this.$route.params.tabIndex + 1,
                    numberRowsPerPage: this.$route.query.numberRowsPerPage,
                  },
                },
              });
            });
          });
        }
      });
    },
    confirmOrder(id) {
      this.$swal({
        title: "آیا از تایید این سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.disabled = true;
          this.confirmBasketOrder(id).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "سفارش مورد‌نظر تایید شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.push({
                path: "/ChannelBaskets/Index",
                query: {
                  referencePageInfo: {
                    tabIndex: +this.$route.params.tabIndex + 1,
                    numberRowsPerPage: this.$route.query.numberRowsPerPage,
                  },
                },
              });
            });
          });
          setTimeout(() => {
            this.disabled = false;
          }, 3000);
        }
      });
      this.showDescriptionDateSettlement = false;
    },
    rejectOrder(id) {
      (async () => {
        const { value: reasonOfReject } = await this.$swal({
          input: "textarea",
          inputLabel: "Message",
          title: "آیا از رد این سفارش اطمینان دارید؟",
          inputPlaceholder: "علت رد سفارش...",
          inputAttributes: {
            required: true,
          },
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ثبت",
          cancelButtonText: "بستن",
        });
        if (reasonOfReject) {
          this.disabledReject = true;
          var basketId = id;
          this.rejectBasketOrder({ reasonOfReject, basketId }).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "سفارش مورد‌نظر رد شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.push({
                path: "/ChannelBaskets/Index",
                query: {
                  referencePageInfo: {
                    tabIndex: this.$route.params.tabIndex,
                    numberRowsPerPage: this.$route.query.numberRowsPerPage,
                  },
                },
              });
            });
          });
          setTimeout(() => {
            this.disabledReject = false;
          }, 3000);
        }
      })();
    },
    orderDelivered(id) {
      this.$swal({
        title: "آیا از تعیین وضعیت این سفارش اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.disabledDelivered = true;
          this.basketOrderDelivered(id).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "سفارش مورد نظر به وضعیت تحویل داده شده تغییر یافت!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.push({
                path: "/ChannelBaskets/Index",
                query: {
                  referencePageInfo: {
                    tabIndex: +this.$route.params.tabIndex + 1,
                    numberRowsPerPage: this.$route.query.numberRowsPerPage,
                  },
                },
              });
            });
          });
          setTimeout(() => {
            this.disabledDelivered = false;
          }, 3000);
        }
      });
    },
    showAttachments() {
      this.showFiles = !this.showFiles;
    },
    onfinish() {
      this.showDescriptionDateSettlement = false;
      this.load();
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/ChannelBaskets/Index",
        query: {
          referencePageInfo: {
            tabIndex: this.$route.params.tabIndex,
            numberRowsPerPage: this.$route.query.numberRowsPerPage,
          },
        },
      });
    },
    showDetials(modelForShowDetials) {
      this.test = modelForShowDetials;
    },
  },
  watch: {
    amountDiscountManual(value) {
      if (value) {
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.discountModel.amount = n;
        this.amountDiscountManual = n.toLocaleString();
      } else {
        this.amount = null;
        this.model.amount = null;
      }
    },
    amountCommissionManual(value) {
      if (value) {
        var m = parseFloat(value.replace(/,/g, ""), 10);
        this.commissionModel.commissionAmount = m;
        this.amountCommissionManual = m.toLocaleString();
      } else {
        this.amount = null;
        this.model.amount = null;
      }
    },
  },
};
</script>
